import { numericParamGuard } from '@shared/utils/route/guards'

/**
 * @constant {string} basePath Base URL path for the package
 * The live Velocity template is served at this path
 * The dev server prepends it to the route paths below
 */
export const basePath = '/projects'

/**
 * @constant {Object} DEFAULT_ERROR_PAGE Default error page for this package
 */
const DEFAULT_ERROR_PAGE = { name: 'projects:not-found' }

/**
 * @constant {Array.Object} routes List of routes for this package
 */
export const routes = [
  {
    path: '/',
    name: 'projects:queue',
    component: () => import('@projects/views/QueueView.vue'),
  },
  {
    path: '/:projectId',
    name: 'projects:details',
    component: () => import('@projects/views/DetailsView.vue'),
    beforeEnter: numericParamGuard('projectId', DEFAULT_ERROR_PAGE),
  },
  {
    path: '/dashboard',
    name: 'projects:dashboard',
    component: () => import('@shared/views/DashboardView.vue'),
  },
  // custom pages
  {
    path: '/orders',
    name: 'pge:orders',
    component: () => import('@customers/pge/views/OrdersView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: DEFAULT_ERROR_PAGE.name,
    component: () => import('@shared/views/NotFoundView.vue'),
  },
]

export default routes
